"use client";

import SearchInput from "@/components/atoms/searchInput/SearchInput";
import { DropdownSelect } from "@/components/molecules/dropdownfilter/SelectDropdown";
import AgentList from "@/components/organisms/AgentList";
import { SORT_BY_MENU } from "@/constants/menu";
import FilterCategory from "@/features/home/components/filterCategory/FilterCategory";
import { useAgentProvider } from "@/features/home/contexts/AgentProvider";
import { Fragment, useEffect, useState } from "react";
import Paginate from "@/components/atoms/paginate/Paginate";
import { useRouter, useSearchParams } from "next/navigation";

export default function ExploreAgents() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const sort = searchParams.get("sort");

  const [sortBy, setSortBy] = useState<string>(SORT_BY_MENU[0].id);

  const {
    isDataAgentsLoading,
    agentsFiltered,
    pageInfo,
    setSortOption,
    setPage,
    setIsFiltering,
  } = useAgentProvider();

  const handleSort = (value: string) => {
    setSortOption?.(value);
    router.push(`/explore?sort=${value}`);
  };

  useEffect(() => {
    let isMounted = true;
    if (!isMounted) return;

    // Always set isFiltering to true when the page is loaded because the default from the server is not provided in this page
    setIsFiltering?.(true);

    return () => {
      isMounted = false;
    };
  }, [setIsFiltering]);

  useEffect(() => {
    let sortBy = SORT_BY_MENU[0].id;
    if (sort) {
      const findSortBy = SORT_BY_MENU.find((e) => e.id === sort);
      if (findSortBy) {
        sortBy = findSortBy.id;
      }
    }

    setSortBy(sortBy);
  }, [sort]);

  return (
    <Fragment>
      <div className="max-w-[1200px] mx-auto px-2 sm:px-4">
        <SearchInput className="mb-3 sm:mb-[23px]" />

        <FilterCategory className="mx-auto mb-[30px] sm:mb-[61px]" />

        <div className="gap-7 flex flex-col">
          {/* DropdownSelect */}
          <DropdownSelect
            triggerClassName="px-4 py-2.5 w-[140px] !rounded-none h-auto bg-white ml-auto"
            contentClassName="mt-1"
            defaultValue={SORT_BY_MENU[0].id}
            menuList={SORT_BY_MENU}
            contentAlign="end"
            value={sortBy}
            onValueChange={handleSort}
          />
          <div className="flex flex-col gap-12">
            {/* If Filtering */}
            <section>
              <AgentList
                dataAgents={agentsFiltered || []}
                isDataAgentsLoading={isDataAgentsLoading || false}
              />
              <Paginate
                className="mt-[74] mb-[99px]"
                pageSelected={pageInfo?.pages || 1}
                pageCount={pageInfo?.totalPages || 1}
                handlePageClick={(event) => {
                  setPage?.(event.selected + 1);
                  setIsFiltering?.(true);
                }}
              />
            </section>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
